function SkeletonLine({ width = "100%" }: Readonly<{ width?: string }>) {
  return <div className="skeleton-line" style={{ width }} />;
}

export function EvaluationListSkeleton() {
  return (
    <div className="evaluation-list">
      <div className="eval-list-header">
        <div className="skeleton-line" style={{ height: "28px", width: "140px" }} />
        <div
          className="skeleton-line"
          style={{ borderRadius: "var(--radius)", height: "36px", width: "150px" }}
        />
      </div>
      <div className="eval-list-section">
        <div
          className="skeleton-line"
          style={{ height: "16px", marginBottom: "12px", width: "100px" }}
        />
        <div className="eval-cards">
          {[1, 2, 3].map((i) => (
            <div key={i} className="eval-card skeleton-card">
              <div
                style={{ display: "flex", justifyContent: "space-between", marginBottom: "8px" }}
              >
                <SkeletonLine width="60%" />
              </div>
              <div style={{ display: "flex", gap: "12px", marginBottom: "10px" }}>
                <SkeletonLine width="120px" />
                <SkeletonLine width="100px" />
              </div>
              <SkeletonLine width="100%" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
